import React from 'react';
import Table from '../../components/common/Table';
import { ActivitySpeciesDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { ActivitySpeciesTypeConstants } from '../../constants/ActivitySpeciesTypeConstants';

interface ActivitySpeciesTableProps {
  data: ActivitySpeciesDTO[];
  handleEdit: (row: ActivitySpeciesDTO) => void;
  handleDelete: (row: ActivitySpeciesDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ActivitySpeciesTable: React.FC<ActivitySpeciesTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Type',
          key: 'activitySpeciesTypeId',
          render: (row: ActivitySpeciesDTO) => {
            const speciesTypeTitle = row.activitySpeciesTypeId === ActivitySpeciesTypeConstants.NOT_ON_LIST
              ? row.speciesOther
              : (row as any).activitySpeciesTypeTitle || row.activitySpeciesType?.title || 'Unknown';
            return <span>{speciesTypeTitle}</span>;
          },
        },

        {
          label: 'Gender',
          key: 'genderId',
          render: (row: ActivitySpeciesDTO) => (
            <span>
              {(row as any).genderTitle ||
                row.gender?.title ||
                'Unknown'}
            </span>
          ),
        },

        {
          label: 'Total',
          key: 'total',
        },

        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ActivitySpeciesTable;